import type { AmzHistorySource, AmzProductRow, AmzSeverity } from "../../types/amazon";

export type Tone = "success" | "warning" | "error" | "info" | "neutral" | "accent";

export type DetailTab = "overview" | "page" | "images" | "issues" | "history";
export type AmazonView = "dashboard" | "products" | "detail" | "history" | "library";
export type ProductFilter = "all" | "review" | "error" | "unregistered" | "updated";

export const SEVERITY_TONE: Record<AmzSeverity, Tone> = {
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const SOURCE_TONE: Record<AmzHistorySource, Tone> = {
  MANUAL: "neutral",
  AI: "accent",
  AMAZON_SYNC: "info",
  SYSTEM: "neutral",
};

/** 商品一覧「商品ページ」列のバッジ。 */
export function pageStatus(r: Pick<AmzProductRow, "registered" | "syncError" | "draftChanges">): { label: string; tone: Tone } {
  if (r.syncError) return { label: "同期エラー", tone: "error" };
  if (!r.registered) return { label: "未登録", tone: "neutral" };
  if (r.draftChanges > 0) return { label: "変更あり", tone: "accent" };
  return { label: "同期済み", tone: "success" };
}

export function issueTone(r: Pick<AmzProductRow, "issues">): Tone {
  if (r.issues.error > 0) return "error";
  if (r.issues.warning > 0) return "warning";
  if (r.issues.info > 0) return "info";
  return "neutral";
}

export function errorMessage(e: unknown): string {
  return e instanceof Error ? e.message : "不明なエラーが発生しました。";
}
